/**
 * Station telemetry error_msg is typically a JSON object
 * (e.g. SafetyController report: {"Pump #2 overpressure":"0"}).
 * Plain text is shown as-is.
 */

function formatJsonValue(value: unknown): string {
  if (value === null || value === undefined) {
    return ''
  }
  if (typeof value !== 'object') {
    return String(value)
  }
  if (Array.isArray(value)) {
    return value
      .map(item => formatJsonValue(item))
      .filter(Boolean)
      .join('\n')
  }
  return Object.entries(value as Record<string, unknown>)
    .map(([key, nested]) => {
      if (nested !== null && typeof nested === 'object') {
        const inner = formatJsonValue(nested)
        return inner ? `${key}:\n${inner}` : key
      }
      return `${key}: ${nested}`
    })
    .join('\n')
}

/** Pretty-print station/lot error_msg for Status / Diagnostics UI. */
export function formatStationErrorMsg(raw: string | null | undefined): string {
  const text = String(raw ?? '').trim()
  if (!text) {
    return ''
  }
  const candidates = [text, text.replace(/;+\s*$/, '').trim()]
  for (const candidate of candidates) {
    if (!candidate) continue
    try {
      return formatJsonValue(JSON.parse(candidate)) || candidate
    } catch {
      /* try next */
    }
  }
  return text
}
